import React from 'react';
import ActionButtonsGroup from '../../../../../components/action_buttons_group/ActionButtonsGroup';

export const customTableColumns = (onEdit, onDelete) => [
  {
    id: "drag",
    Header: "",
    Filter: "",
    Cell: () => <i className="material-icons">drag_indicator</i> 
  },
  {
    Header: "Pregunta",
    accessor: "name",
  },
  {
    Header: "Tipo de pregunta",
    accessor: "questionType",
  },
  {
    id: "customButtons",
    Header: "Acciones",
    Filter: "",
    Cell: ({ row }) => {
      const { original } = row;
      const buttons = [
        {
          icon: 'edit',
          name: 'edit',
          id: 'edit',
          func: () => onEdit(original),
          text: '',
          variant: 'link'
        },
        {
          icon: 'close',
          name: 'delete',
          id: 'delete',
          func: () => onDelete(original.id),
          text: '',
          variant: 'link',
          className: 'text-danger'
        }
      ];
      return <ActionButtonsGroup buttons={buttons} />;
    },
  }
];
